/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/button-has-type */
import { CloseOutlined } from "@ant-design/icons";
import { Image, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import DocumentIcon from "../../../icons/js/DocumentIcon";
import { formatBytes } from "../../../library/utils";
import AntdIconV4 from "../../../utils/antdIcon";
import { ViewMediaPopup } from "./mediaSharing/ViewMediaPopup";
import { ModalStyled } from "./mediaSharing/multipleMediaViewer";

const Attachments = ({ attachments, setAttachments }) => {
  const [activekey, setactivekey] = useState(1);
  const [pdfModal, setpdfModal] = useState({
    visible: false,
    pdfUrl: "",
    mediaType: "",
  });
  const [imageModalVisible, setImageModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState({});
  const handleDeleteAttachment = index => {
    const updatedAttachments = [...attachments];
    const removedAttachment = updatedAttachments[index];
    // Clean up blob URL to prevent memory leaks
    if (removedAttachment?.preview && removedAttachment.preview.startsWith("blob:")) {
      URL.revokeObjectURL(removedAttachment.preview);
    }
    updatedAttachments.splice(index, 1);
    setAttachments(updatedAttachments);
  };
  const handleImageModalClose = () => {
    setCurrentImage({});
    setImageModalVisible(false);
  };
  const handleImageClick = image => {
    setCurrentImage(image);
    setImageModalVisible(true);
  };
  useEffect(() => {
    setactivekey(1);
  }, [attachments]);
  return (
    <div>
      {attachments.length > 0 && (
        <div className="flex flex-row h-[100px] w-full items-center gap-2.5">
          <Image.PreviewGroup>
            {attachments.map((attachment, index) => {
              const size = formatBytes(attachment.file.size);
              return (
                <AttachmentRender
                  key={index}
                  index={index}
                  attachment={attachment}
                  handleImageClick={handleImageClick}
                  setpdfModal={setpdfModal}
                  handleDeleteAttachment={handleDeleteAttachment}
                  size={size}
                />
              );
            })}
          </Image.PreviewGroup>
        </div>
      )}
      {imageModalVisible && (
        <ModalStyled
          width="97.5%"
          style={{ top: "20px" }}
          className="transparent-popup"
          open={imageModalVisible}
          closeIcon={<AntdIconV4 type="CloseOutlined" className="text-white" />}
          onCancel={handleImageModalClose}
          footer={null}
          title="View Video"
        >
          <video width="100%" height="100%" controls>
            <source src={currentImage.preview} type={currentImage.file.type} />
          </video>
        </ModalStyled>
      )}
      {pdfModal.visible && <ViewMediaPopup pdfModal={pdfModal} setpdfModal={setpdfModal} />}
    </div>
  );
};

export default Attachments;
function AttachmentRender({
  index,
  attachment,
  handleImageClick,
  setpdfModal,
  handleDeleteAttachment,
  size,
}) {
  const [showDelete, setshowDelete] = useState(false);
  return (
    <div
      className="flex flex-col w-fit"
      onMouseEnter={() => setshowDelete(true)}
      onMouseLeave={() => setshowDelete(false)}
      key={index}
    >
      <div className="inline-block w-full h-full relative rounded overflow-hidden">
        {attachment.file.type.includes("image") ? (
          <div className="p-2 rounded-lg border-solid border-[1px] border-grey-200">
            <Image
              className="aspect-video object-contain"
              src={attachment.preview}
              width="80px"
              height="80px"
            />
          </div>
        ) : attachment.file.type.includes("video") ? (
          <div className="p-2 rounded-lg border-solid border-[1px] border-grey-200">
            <video
              style={{
                width: "120px",
                height: "80px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#F0F0F0",
                cursor: "pointer",
              }}
              onClick={() => handleImageClick(attachment)}
            >
              <source src={attachment.preview} type="video/mp4" />
            </video>
          </div>
        ) : (
          <div
            onClick={() =>
              setpdfModal({
                visible: true,
                pdfUrl: attachment.preview,
                mediaType: attachment.file.type,
              })
            }
            className="p-2 cursor-pointer h-[100px] flex-col-centered items-center justify-center rounded-lg border-[1px] border-solid border-grey-200"
          >
            <span className="flex-col-centered h-full gap-1.5 items-center justify-center rounded-[4px] bg-grey-100 p-2">
              <DocumentIcon />
              <Tooltip title={attachment.file.name}>
                <span className="ellipsis w-[60px]">{attachment.file.name}</span>
              </Tooltip>
            </span>
          </div>
        )}
        {showDelete && (
          <button
            className="absolute top-[5px] right-[5px] z-[1] p-0.5 bg-slate-600 text-white rounded-full w-5 h-5 flex justify-center items-center cursor-pointer border-none "
            onClick={e => {
              e.stopPropagation();
              handleDeleteAttachment(index);
            }}
          >
            <CloseOutlined />
          </button>
        )}
      </div>
      <span className="text-sm flex flex-row items-center gap-1 justify-center font-[500]">
        {size}
      </span>
    </div>
  );
}
